module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowBold.dbc5d79.ttf";